import { agentHarnessKeys } from '@heidi/agents/contracts';
import { getWorkHostPort } from '../../work-home/work-home-ports';
import { cancelComputerUseRunSettled } from './cancel-computer-use-run-settled';

/**
 * Cancel a computer-use run. On the cutover path, pass the CHILD run id: the BE
 * posts the cancelled tool result on the parent stream and the parent turn stays
 * alive to react — never cancel the parent to stop a desktop task.
 *
 * BE is the source of truth: cancel the turn server-side and let derived run
 * state confirm it. The run-owned executor stop is a latency bonus only — the
 * executor also stops when the child stream ends. Never starts a new conversation.
 */
export const cancelComputerUseRun = (agentRunId: string): void => {
  void cancelComputerUseRunSettled(agentRunId, () => {
    void getWorkHostPort('shell').reactQueryClient.invalidateQueries({
      queryKey: agentHarnessKeys.run(agentRunId),
    });
  });
};
